import { useQuery } from "@tanstack/vue-query"
import {
  CensusApiListCompanyMemberCensusUploadAuditLogsRequest,
  CompanyMemberCensusUploadAuditLog,
  ListCompanyMemberCensusUploadAuditLogsResponse
} from "@vitable/asclepius-api-client-ts"
import { reactive, Reactive } from "vue"
import { QueryApiCacheKeys } from "../config/query-api-cache-keys"
import useAsclepius from "./api/asclepius"
import { Mutable, PageData } from "src/types"

export function useListCompanyMemberCensusUploadAuditLogs(
  options: CensusApiListCompanyMemberCensusUploadAuditLogsRequest
) {
  const { getCensusApi, callWithResponse, callResult: listCompanyMemberCensusUploadAuditLogsResult } = useAsclepius()

  const request: Reactive<Mutable<CensusApiListCompanyMemberCensusUploadAuditLogsRequest>> = reactive({
    companyId: options.companyId,
    companyMemberType: options.companyMemberType,
    uploadType: options.uploadType,
    createdDateGt: options.createdDateGt,
    page: options.page,
    limit: options.limit
  })

  async function listCompanyMemberCensusUploadAuditLogs(): Promise<PageData<CompanyMemberCensusUploadAuditLog>> {
    const data: ListCompanyMemberCensusUploadAuditLogsResponse = await callWithResponse(() =>
      getCensusApi().listCompanyMemberCensusUploadAuditLogs(request)
    )

    return {
      count: data.count,
      results: data.results
    }
  }

  const useListCompanyMemberCensusUploadAuditLogsQuery = () => {
    return useQuery({
      queryKey: [
        QueryApiCacheKeys.COMPANY_MEMBER_CENSUS_UPLOAD_AUDIT_LOGS,
        request.companyId,
        request.companyMemberType,
        request.uploadType,
        request.createdDateGt,
        request.page,
        request.limit
      ],
      queryFn: listCompanyMemberCensusUploadAuditLogs
    })
  }

  return {
    useListCompanyMemberCensusUploadAuditLogsQuery,
    request,
    listCompanyMemberCensusUploadAuditLogsResult,
    listCompanyMemberCensusUploadAuditLogs
  }
}

export function useMarkNoEmployeeCensusChange() {
  const { getCensusApi, callWithResponse, callResult: result } = useAsclepius()

  async function markNoEmployeeCensusChange(companyId: string) {
    await callWithResponse(() => getCensusApi().markNoEmployeeCensusChange({ companyId }))
  }

  return {
    result,
    markNoEmployeeCensusChange
  }
}
